export enum ClientServices {
    APPOINTMENT = "Appointment",
    MANUAL = "Manual",
    MESSAGE = "Message",
    REQUEST = "Request"
}